<template>
  <div class="pr-3">
    <v-container class="ml-10 pr-10">
      <p class="display-1 mt-7">인증 코드 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        생성한 시리얼 인증 코드에 대한 내역을 확인하고 관리합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        고객 주문시 시리얼 인증코드를
        <!--<font style="color:#9C9C9C">-->SMS<!--</font>-->
        및 메일을 자동 발송처리되며 인증완료 상태로 변경됩니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        고객 요청에 따라 재발송처리도 가능하오니 참고해주세요.
      </p>

      <ManageAuthCodeSearch ref="searchComponent"></ManageAuthCodeSearch>
      <ManageAuthCodeList ref="listComponent"></ManageAuthCodeList>
    </v-container>
  </div>
</template>

<script>
import ManageAuthCodeSearch from "@/components/authservice/authcode/ManageAuthCodeSearch.vue";
import ManageAuthCodeList from "@/components/authservice/authcode/ManageAuthCodeList.vue";

export default {
  data: () => ({}),
  components: {
    ManageAuthCodeSearch,
    ManageAuthCodeList
  }
};
</script>
